import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import './fonts/myFont.css'
import "./styles/index.scss"

import qs from 'qs'
import i18n from './i18n/i18n'
import ElementUI from 'element-ui'

import zoonHeader from './components/zoonHeader/index'
import zoonFooter from './components/zoonFooter/index'
import bottomBar from './components/bottomBar/index'
import announcements from './components/announcement/index'

import EventBus from './utils/bus.js'
import DecentralizedApi from './decentralizedApi/decentralizedApi.js'

import Vant from 'vant';
import 'vant/lib/index.less';
import '@vant/touch-emulator';

import VueTippy, {TippyComponent} from "vue-tippy";
// Add additional themes.
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

import Message from '@/components/messageToast/index';
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;
// 挂载到原型上当成属性调用
Vue.prototype.$QS = qs;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$decentralized = DecentralizedApi;

// 开发环境使用，生产环境自动取消
// if (process.env.NODE_ENV === "development") {
//   const vConsole = new VConsole({ theme: 'dark' });
// }

Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  interactive: true,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    }
  }
});
// 全局引入插件或者组件
Vue.component("tippy", TippyComponent);
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(zoonHeader);
Vue.use(zoonFooter);
Vue.use(announcements);
Vue.use(bottomBar);
Vue.use(Message);

Vue.use(VueClipboard)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
